import modules from '@/components/modules'

export default {
  install (Vue) {
    Vue.prototype.$modules = modules
  }
}